import { createBrowserRouter } from "react-router-dom";
import React, { Suspense } from "react";
import Main from "views/Main";

const Home = React.lazy(() => import("views/Home"));
const EyeCareDetails = React.lazy(() => import("views/EyeCareDetails"));
const EyeCareInternal = React.lazy(() => import("views/EyeCareInternal"));
const Blog = React.lazy(() => import("views/Blog"));
const Blogs = React.lazy(() => import("views/Blogs"));
const ContactUs = React.lazy(() => import("views/ContactUs"));
const Doctors = React.lazy(() => import("views/Doctors"));
const HealthCheckup = React.lazy(() => import("views/HealthCheckup"));
const WaveLightPlus = React.lazy(() => import("views/WaveLightPlus/WaveLightPlus"));
const NotFoundPage = React.lazy(() => import("views/NotFoundPage"));
const Doctorsdetails = React.lazy(() => import("views/Doctors/Doctorsdetails"));

const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw' }}>Loading...</div>}>
    {children}
  </Suspense>
);


export const departmentConstants = {
  OPHTHALMOLOGY: "ophthalmology",
  ORTHO: "ortho",
  PEDIATRICS: "pediatrics",
  GYNO: "gyno",
  DERMA: "dermatology",
  INTERNAL_MEDICINE: "internalMedicine",
  DIBETOLOGY: "diabetology",
  GEN_SURGERY: "generalSurgery",
  ENT: "ent",
  CARDIO: "cardiology",
  NEPHRO: "nephrology",
  NEURO: "neurology",
  PHYSIO: "physiotherapy",
  GASTRO: "gastroenterology",
  RADIO: "radiology",
  CC: "criticalCare",
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        element: <SuspenseWrapper><Home /></SuspenseWrapper>,
        index: true, 
      },
      {
        path: "department/:departmentId",
        element: <SuspenseWrapper><EyeCareDetails /></SuspenseWrapper>,
      },
      {
        path: "department-internal/ophthalmology/wavelight-plus",
        element: <SuspenseWrapper><WaveLightPlus /></SuspenseWrapper>,
      },
      {
        path: "department-internal/:departId/:id",
        element: <SuspenseWrapper><EyeCareInternal /></SuspenseWrapper>,
      },
      {
        path: "our-doctor",
        element: <SuspenseWrapper><Doctors doctorView /></SuspenseWrapper>,
      },
       {
        path: "Doctors/:slug",
        element: <SuspenseWrapper><Doctorsdetails /></SuspenseWrapper>,
      },
      {
        path: "blog",
        element: <SuspenseWrapper><Blogs /></SuspenseWrapper>,
      },
      {
        path: "blog/:slug",
        element: <SuspenseWrapper><Blog /></SuspenseWrapper>,
      },
      {
        path: "contact",
        element: <SuspenseWrapper><ContactUs /></SuspenseWrapper>,
      },
      {
        path: "health-checkup",
        element: <SuspenseWrapper><HealthCheckup /></SuspenseWrapper>,
      },
      {
        path: "waveLight-plus",
        element: <SuspenseWrapper><WaveLightPlus /></SuspenseWrapper>,
      },
      {
        path: "wavelight-plus",
        element: <SuspenseWrapper><WaveLightPlus /></SuspenseWrapper>,
      },
      {
        path: "404",
        element: <SuspenseWrapper><NotFoundPage /></SuspenseWrapper>, 
      },
    ],
  },
]);

export default router;
